import { render } from "./EditGlobalPriceForm.vue?vue&type=template&id=165e58b8&ts=true"
import script from "./EditGlobalPriceForm.vue?vue&type=script&lang=ts"
export * from "./EditGlobalPriceForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__